import { debounce } from "throttle-debounce";
import * as List from "list.js";
import { compareAsc, parse } from "date-fns";

const Bankruptcy = (target) => {
  const el = {
    search: target.querySelector(".bankruptcy__search"),
    links: target.querySelectorAll(".bankruptcy__list--button"),
    list: target.querySelector(".bankruptcy__table"),
    items: target.querySelectorAll(".bankruptcy__result--table"),
  };

  let bankruptcyList = null;

  const method = {
    init: () => {
      el.links.forEach((link) => {
        link.addEventListener("click", method.getCompanyDetails);
      });

      if (el.search) {
        el.search.addEventListener("keyup", debounce(500, method.search));

        bankruptcyList = new List(target, {
          valueNames: [
            "bankruptcy__list--ssn",
            "bankruptcy__list--name",
            "bankruptcy__list--date",
            "bankruptcy__details",
            "bankruptcy__list--button",
          ],
          listClass: "bankruptcy__list",
        });
      }
    },

    searchRequest: (searchString) => {
      return fetch(
        "/umbraco/surface/Bankruptcy/SearchBankruptcy?searchString=" +
          searchString
      )
        .then((res) => {
          if (!res.ok) {
            throw new Error(res.statusText);
          }
          return res.json();
        })
        .then((data) => {
          return data.result;
        })
        .catch((err) => {
          console.log("err: ", err);
          throw err;
        });
    },

    renderShowButton: (ssn) => {
      return `<button data-key="${ssn}">
                  <span aria-hidden="false">${window.dictionary.BR_ViewDetails}</span>
                  <span aria-hidden="true">${window.dictionary.BR_HideDetails}</span>
              </button>`;
    },

    renderCompanyDetails: (company) => {
      return `<div colspan="4" aria-hidden="true" id="#company-${company.SSN}">
                <div class="table__wrap">
                    <table>
                        <tbody>
                            <tr>
                                <td>${window.dictionary.BR_Company}</td>
                                <td>${company.Name}</td>
                            </tr>
                            <tr>
                                <td>${window.dictionary.BR_SSN}</td>
                                <td>${company.SSN}</td>
                            </tr>
                            <tr>
                                <td>${window.dictionary.BR_DateOfRuling}</td>
                                <td>${company.DateOfRuling}</td>
                            </tr>
                            <tr>
                                <td>${window.dictionary.BR_PublicationDay}</td>
                                <td>${company.PublicationDay}</td>
                            </tr>
                            <tr>
                                <td>${window.dictionary.BR_Deadline}</td>
                                <td>${company.Deadline}</td>
                            </tr>
                            <tr>
                                <td>${window.dictionary.BR_Liquadator}</td>
                                <td>${company.Liquidator}</td>
                            </tr>
                            <tr>
                                <td>${window.dictionary.BR_MeetingLocation}</td>
                                <td>${company.MeetingLocation}</td>
                            </tr>
                            <tr>
                                <td>${window.dictionary.BR_MeetingDay}</td>
                                <td>${company.MeetingDay}</td>
                            </tr>
                            <tr>
                                <td>${window.dictionary.BR_MeetingDay}</td>
                                <td>${company.MeetingTime}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>`;
    },

    search: async (event) => {
      if (event.target.value.length > 1) {
        const results = await method.searchRequest(event.target.value);

        results.forEach((res) => {
          if (
            bankruptcyList.items.filter(
              (item) => item.values()["bankruptcy__list--ssn"] == res.SSN
            ).length == 0
          )
            bankruptcyList.add({
              "bankruptcy__list--ssn": res.SSN,
              "bankruptcy__list--name": res.Name,
              "bankruptcy__list--date": res.DateOfRuling,
              bankruptcy__details: method.renderCompanyDetails(res),
              "bankruptcy__list--button": method.renderShowButton(res.SSN),
            });
        });

        bankruptcyList.sort("bankruptcy__list--date", {
          order: "desc",
          sortFunction: (a, b) => {
            const t1 = a.values()["bankruptcy__list--date"];
            const t2 = b.values()["bankruptcy__list--date"];

            const d1 = parse(t1, "dd.MM.yyyy", new Date());
            const d2 = parse(t2, "dd.MM.yyyy", new Date());

            return compareAsc(d1, d2);
          },
        });
        document
          .querySelectorAll(".bankruptcy__list--button")
          .forEach((element) => {
            element.addEventListener("click", method.getCompanyDetails);
          });
      }

      if (event.target.value.length > 1) {
        bankruptcyList.search(event.target.value, [
          "bankruptcy__list--ssn",
          "bankruptcy__list--name",
        ]);
      } else {
        bankruptcyList.search();
      }
    },

    getCompanyDetails: (event) => {
      const details = event.currentTarget.nextElementSibling;
      const isOpened = event.currentTarget.classList.contains(
        "bankruptcy__list--button-opened"
      );

      event.currentTarget.classList.toggle("bankruptcy__list--button-opened");

      var hiddenEl = event.currentTarget.querySelector("[aria-hidden='true']");

      var visibleEl = event.currentTarget.querySelector(
        "[aria-hidden='false']"
      );

      hiddenEl.setAttribute("aria-hidden", false);
      visibleEl.setAttribute("aria-hidden", true);

      details.setAttribute("aria-hidden", isOpened);
    },
  };

  method.init();
};

export default Bankruptcy;
